import { useSyncExternalStore } from "react";

/**
 * Estado del buscador de fichas (abierto o cerrado), compartido entre el botón «Buscar»
 * (barra lateral, cabecera móvil, Ctrl+K) y la ventana del buscador. Sin dependencias.
 */
let abierto = false;
const oyentes = new Set<() => void>();
const avisar = () => oyentes.forEach((f) => f());

export const abrirBuscador = () => {
  abierto = true;
  avisar();
};
export const cerrarBuscador = () => {
  abierto = false;
  avisar();
};
export const useBuscadorAbierto = () =>
  useSyncExternalStore(
    (f) => {
      oyentes.add(f);
      return () => oyentes.delete(f);
    },
    () => abierto,
  );
